import Vue from 'vue';
import Vuelidate from 'vuelidate';
import {
  getAttribute,
  setAttribute
} from '../util';
import {
  required,
  minValue,
  integer,
  helpers
} from 'vuelidate/lib/validators';
import {
  regex
} from 'vuelidate/lib/validators/common';

/* global asprhe_product, wp */

Vue.use(Vuelidate);

const SELECTORS = {
  TEST: 'body.post-type-asprhe_product form#post input#title',
  FORM: 'form#post',
  TITLE: 'form#post input#title'
};

const money = regex('money', /^[1-9](\d+)?\.\d{2}$/);
// eslint-disable-next-line camelcase
const required_if_boiler_service = function(value) {
  return 0 === this.benefits.benefits.annual_boiler_service || helpers.req(value);
};
// eslint-disable-next-line camelcase
const unique_excess = function(value) {
  return 1 === this.premiums.filter(({ excess }) => parseInt(value, 10) === parseInt(excess, 10)).length;
};

export default {
  test: SELECTORS.TEST,
  // eslint-disable-next-line padded-blocks
  vue() {

    window.asprhe_product = window.asprhe_product || {};

    setAttribute(SELECTORS.FORM, 'v-on:submit', 'onSubmit');
    setAttribute(SELECTORS.TITLE, 'required', 'title');

    // eslint-disable-next-line no-new
    new Vue({
      el: 'body.post-type-asprhe_product form#post',

      data: {
        // eslint-disable-next-line camelcase
        ...asprhe_product
      },

      validations: {
        cover_level: {
          amount: {
            required,
            integer,
            minValue: minValue(1)
          },
          terms_and_conditions: {
            required,
            integer
          }
        },
        premiums: {
          required,
          $each: {
            excess: {
              required,
              integer,
              unique_excess
            },
            month: {
              money
            },
            year: {
              money
            }
          }
        },
        benefits: {
          benefits: {
            plumbing: {
              required
            },
            electrical: {
              required
            },
            external_locks_doors_windows: {
              required
            },
            blocked_pipes: {
              required
            },
            pests: {
              required
            },
            lost_keys: {
              required
            },
            central_heating: {
              required
            },
            boiler_breakdown: {
              required
            },
            alternative_accommodation: {
              required
            },
            roofing: {
              required
            },
            annual_boiler_service: {
              required
            }
          },
          terms_and_conditions: {
            integer,
            required_if_boiler_service
          }
        }
      },

      watch: {
        'benefits.benefits.annual_boiler_service'() {
          this.removeTermsAndConditions('benefits');
        }
      },

      methods: {
        addPremium() {
          this.premiums.push({
            excess: null,
            month: null,
            year: null
          });
        },

        addTermsAndConditions(type) {
          let media = wp
            .media({
              title: 'Select Terms & Conditions File',
              multiple: false
            })
            .open()
            .on('select', () => {
              let selectedItem = media.state().get('selection').first();

              this[type].terms_and_conditions = selectedItem.attributes.id;
              this.meta[type].terms_and_conditions = selectedItem.attributes.url;

              media.close();
            })
          ;
        },
        removeTermsAndConditions(type) {
          this[type].terms_and_conditions = null;
          this.meta[type].terms_and_conditions = null;
        },

        onSubmit(e) {
          if ('auto-draft' !== getAttribute('#original_post_status', 'value') && this.$v.$invalid) {
            e.preventDefault();
          }
        }
      }
    });

  } // eslint-disable-line padded-blocks
};
